import React from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineGavel } from "react-icons/md";
import { FaUserShield } from "react-icons/fa";
import { useSession } from "../context/SessionContext";
import { cn } from "../components/ui/cn";
import { t } from "../i18n";
import { PATHS } from "./paths";

const SUPPORT_URL = "https://wa.me/5521995054004?text=Oi,%20preciso%20de%20ajuda%20com%20LetsDoc.";

type Item = { label: string; icon: React.ReactNode; to?: string; href?: string };

const image = (src: string) => <img src={src} alt="" className="h-6 w-6" />;

/** Menu inferior fixo das telas do app. `current` é o pathname aberto. */
export const FooterMenu: React.FC<{ current: string }> = ({ current }) => {
  const navigate = useNavigate();
  const { adminStatus } = useSession();

  const items: Item[] = [
    { label: t("nav.newOrder"), icon: image("/plus-icon.svg"), to: PATHS.newOrder },
    { label: t("nav.savedOrders"), icon: image("/saved-icon.svg"), to: PATHS.savedOrders },
    { label: t("nav.appeals"), icon: <MdOutlineGavel className="h-6 w-6 text-primary" aria-hidden />, to: PATHS.appeals },
    { label: t("nav.support"), icon: image("/support-icon.svg"), href: SUPPORT_URL },
    ...(adminStatus?.is_admin ? [{ label: t("nav.admin"), icon: <FaUserShield className="h-6 w-6 text-primary" aria-hidden />, to: PATHS.admin }] : []),
    { label: t("nav.settings"), icon: image("/account.png"), to: PATHS.settings },
  ];

  return (
    <nav aria-label={t("nav.label")} className="fixed inset-x-0 bottom-0 z-30 flex h-nav items-center justify-around border-t border-line bg-surface pb-safe">
      {items.map(({ label, icon, to, href }) => {
        const active = to === current;
        return (
          <button
            key={label}
            type="button"
            aria-current={active ? "page" : undefined}
            onClick={() => (to ? navigate(to) : window.open(href, "_blank", "noopener,noreferrer"))}
            className={cn(
              "flex min-h-control-touch flex-col items-center justify-center gap-1 px-1 text-badge",
              active ? "text-primary" : "text-fg-muted"
            )}
          >
            {/* Só o ícone fica apagado: o texto inativo mantém 4,5:1 de contraste. */}
            <span className={cn(!active && "opacity-60")}>{icon}</span>
            {label}
          </button>
        );
      })}
    </nav>
  );
};
